// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"83547fe1","383":"eff9843e","488":"af7e4ee1","517":"4c67cec4","653":"b871dca3","661":"af846814","787":"f8e0379c"}[chunkId] + ".chunk.js";
};